export default () => ({
  pages: {}
})
